<template>
  <div>
    <span class="text text-grey fs-14">
      {{ isLogin ? $t('Read our') : $t('By signing up, you agree to the') }}
      <a class="link" :href="TERMS_OF_SERVICE" target="_blank">{{ $t('Terms of Service') }}</a
      >, <a class="link" :href="PRIVACY_POLICY" target="_blank">{{ $t('Privacy Policy') }}</a
      >, <a class="link" :href="GDPR_POLICY" target="_blank">{{ $t('GDPR Policy') }}</a
      >.
    </span>
  </div>
</template>

<script>
  import { TERMS_OF_SERVICE, PRIVACY_POLICY, GDPR_POLICY } from '@/utils/constants/common';

  export default {
    name: 'TermsAndPolicy',
    props: {
      isLogin: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        TERMS_OF_SERVICE,
        PRIVACY_POLICY,
        GDPR_POLICY,
      };
    },
  };
</script>
